import { Platform } from 'react-native';
import { BottomSheet, Modal, StackNavigationProp } from '@bonanza-social/navigation';
import { StatusResponseType, StatusType } from '../state/status/status.types';
import onboardingAnimations from '../assets/animations/onboarding';
import promotionAnimations from '../assets/animations/promotion';
import images from '../assets/images';

export const openStatusProgressInfo = (
  status: StatusResponseType,
  navigation: StackNavigationProp<AppNavigatorParamsList>,
) => {
  BottomSheet.open({
    namespace: 'status',
    type: 'statusProgressInfo',
    titleNS: 'status',
    titleKey: status.playerStatus,
    borderGradient: `status${status.playerStatus}Background`,
    borderStyle: 'top',
    scrollable: true,
    onInfo: () => navigation.navigate('StatusInfo'),
  });
};

export const openStatusModal = (
  type:
    | 'StatusDemotion'
    | 'StatusPromotion'
    | 'StatusRetention'
    | 'StatusOnboarding',
) => {
  Modal.open({
    namespace: 'status',
    type,
    style: {
      width: '100%',
      height: '100%',
      maxWidth: undefined,
      maxHeight: undefined,
    },
    options: {
      variant: 'transparent',
      hideHeader: true,
      animated: false,
    },
  });
};

export const ASSET_PRELOADERS = {
  Onboarding: () => {
    onboardingAnimations.gemsFlying.mobile();
    onboardingAnimations.gemsFlying.tablet();
    onboardingAnimations.gemsFlying.desktop();

    if (Platform.OS === 'web') {
      Object.keys(images).forEach((name) => {
        if (name.endsWith('Gem')) {
          new Image().src = images[name as keyof typeof images];
        }
      });
    }
  },
  ToBePromoted: () => {
    promotionAnimations.toAmethyst();
    promotionAnimations.toTopaz();
    promotionAnimations.toAquamarine();
    promotionAnimations.toOpal();
    promotionAnimations.toEmerald();
    promotionAnimations.toRuby();
    promotionAnimations.toSapphire();
    promotionAnimations.toDiamond();
    promotionAnimations.toVip();
  },
  ToBeDemoted: () => {
    if (Platform.OS === 'web') {
      Object.keys(images).forEach((name) => {
        if (name.endsWith('Gem') || name.endsWith('Glow')) {
          new Image().src = images[name as keyof typeof images];
        }
      });
    }
  },
  ToBeKept: () => {},
};
